var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skills-container"},[_c('div',{staticClass:"skills-wrap"},_vm._l((_vm.skills),function(skill,index){return _c('div',{key:index,staticClass:"skill-pill"},[_vm._v(_vm._s(skill))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }